export default "__VITE_ASSET__BygEPO0___"